import React from 'react';
import '../App.css';
import Headerappprivateadmin from './/headerappprivateadmin'
import { Bodyappcasinosbody} from './/bodyappcasinosbody'
import { Footerappprivateadmin } from './/footerappprivateadmin'


import withRouter from './/withRouter'
class Bodyappcasinos extends React.Component {
    constructor(props){
        super(props);
    }
  
  componentDidMount(){
          if(this.props.params.loginToken == '')
          {
              window.location = ('/')
          }

  }

  render(){  
    return (  
      <div className="App">        
        <Headerappprivateadmin/>
        <Bodyappcasinosbody />
        <Footerappprivateadmin/>
      </div>
    );
  }
}
export default withRouter(Bodyappcasinos);